(() => {
  const HOME_SELECTOR = '[data-lunea26-home]';

  const addView = (href, view = 'lunea') => {
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return href;
      if (!url.pathname.startsWith('/products/') && !url.pathname.startsWith('/collections/') && url.pathname !== '/search' && url.pathname !== '/cart') return href;
      if (!url.searchParams.has('view')) url.searchParams.set('view', view);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_) {
      return href;
    }
  };

  const keepLuneaContext = (scope = document) => {
    scope.querySelectorAll?.('a[href]').forEach((link) => {
      if (link.classList.contains('lunea-nav__switch') || link.classList.contains('lunea-nav-drawer__switch') || link.classList.contains('lunea-footer__switch')) return;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
      const next = addView(href);
      if (next !== href) link.setAttribute('href', next);
    });
  };

  const bootHome = (scope = document) => {
    const root = scope.querySelector?.(HOME_SELECTOR) || document.querySelector(HOME_SELECTOR);
    if (!root || root.dataset.lunea26Ready === 'true') return;
    root.dataset.lunea26Ready = 'true';
    document.documentElement.classList.add('lunea26-motion');

    const nodes = [...root.querySelectorAll('[data-lunea26-reveal]')];
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.07 });
    nodes.forEach((node) => observer.observe(node));
  };

  const setupDrawer = () => {
    const toggle = document.querySelector('[data-lunea-menu-toggle]');
    const layer = document.querySelector('[data-lunea-menu-layer]');
    if (!toggle || !layer || layer.dataset.lunea27Bound === 'true') return;
    layer.dataset.lunea27Bound = 'true';

    const panel = layer.querySelector('.lunea-nav-drawer__panel');
    const closeButtons = [...layer.querySelectorAll('[data-lunea-menu-close]')];
    const menuLinks = [...layer.querySelectorAll('a[href]')];
    let lastFocused = null;

    const setOpen = (open) => {
      layer.classList.toggle('is-open', open);
      layer.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Fermer le menu Lunea' : 'Ouvrir le menu Lunea');
      document.body.classList.toggle('lunea-menu-open', open);

      if (open) {
        lastFocused = document.activeElement;
        window.requestAnimationFrame(() => panel?.focus({ preventScroll: true }));
      } else if (lastFocused instanceof HTMLElement && document.contains(lastFocused)) {
        lastFocused.focus({ preventScroll: true });
      }
    };

    toggle.addEventListener('click', () => setOpen(!layer.classList.contains('is-open')));
    closeButtons.forEach((button) => button.addEventListener('click', () => setOpen(false)));
    menuLinks.forEach((link) => link.addEventListener('click', () => setOpen(false)));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && layer.classList.contains('is-open')) setOpen(false);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 900 && layer.classList.contains('is-open')) setOpen(false);
    }, { passive: true });
  };

  const init = (scope = document) => {
    keepLuneaContext(scope);
    bootHome(scope);
    setupDrawer();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:reorder', () => init());
})();
